// extracted by mini-css-extract-plugin
module.exports = {"form":"searchname_form__3TkzM","raza":"searchname_raza__2u0KJ"};